import { render, staticRenderFns } from "./FormFirma.vue?vue&type=template&id=3a190f96&scoped=true"
import script from "./FormFirma.vue?vue&type=script&lang=js"
export * from "./FormFirma.vue?vue&type=script&lang=js"
import style0 from "./FormFirma.vue?vue&type=style&index=0&id=3a190f96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a190f96",
  null
  
)

export default component.exports